import { requestApi } from '../util/network'

// 获取服务机构基本信息
export const getOrganizationList =
    (sort_key, class_id, keyword, page) =>
      requestApi(
        '/o2o_fuwu_organization/get_list',
        'POST',
        {
          'sort_key': sort_key,
          'class_id': class_id,
          'keyword': keyword,
          'page': page
        }
      )

// 获取服务机构基本信息
export const getOrganizationInfo =
    (organizationId) =>
      requestApi(
        '/o2o_fuwu_organization/get_info',
        'POST',
        {
          'organization_id': organizationId
        }
      )
export const getReviewList =
    (parmas, o2o_fuwu_organization_id) =>
      requestApi(
        '/o2o_fuwu_organization/get_evaluate_list',
        'POST',
        {
          'page': parmas.page,
          'per_page': parmas.per_page,
          'o2o_fuwu_organization_id': o2o_fuwu_organization_id
        }
      )
export const getFileList =
    (o2o_fuwu_organization_id) =>
      requestApi(
        '/o2o_fuwu_organization/get_file_list',
        'POST',
        {
          'o2o_fuwu_organization_id': o2o_fuwu_organization_id
        }
      )
